module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Настройки уведомлений","subtitle":"Управляйте тем, как вы хотите получать уведомления от системы.","emailLabel":"Получать уведомления на Email","howItWorks":"Как это работает","howItWorksText":"Если включено, важные события и обновления будут дополнительно приходить на вашу почту. Настройку можно изменить в любой момент."}}')
  delete Component.options._Ctor
}
